import React from 'react';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { faUsers, faUserHeadset } from '@fortawesome/pro-duotone-svg-icons';
import Tile from './Tile';

class Hub extends React.PureComponent {
  render() {
    const { translationSites } = this.props;

    return (
      <main className="p-5">
        <Row>
          <Col>
            <h2 className="mb-3 font-weight-bold">Applications</h2>
          </Col>
        </Row>
        <Row>
          {translationSites.consumer !== '' && (
            <Tile
              type="consumer"
              name="Consumer Portal"
              description="Consumer facing quoting and medicine cabinet portal."
              icon={faUsers}
            />
          )}
          {translationSites.agent !== '' && (
            <Tile
              type="agent"
              name="Agent Portal"
              description="Agent facing quoting and medicine cabinet portal."
              icon={faUserHeadset}
            />
          )}
        </Row>
      </main>
    );
  }
}

const mapStateToProps = (store) => ({
  translationSites: store.translations.translationSites,
});

export default connect(mapStateToProps)(Hub);
